import { useNavigate, useParams } from "react-router";

import { CompanyEditSheet } from "./CompanyEditSheet";
import { CompanyShow } from "./CompanyShow";

/**
 * /companies/:id on a phone (the edit route, e.g. a deep link): the edit
 * sheet over the company's show page. Closing or saving lands on the show
 * page, replacing the edit entry so Back doesn't reopen the form.
 */
export const CompanyEditMobile = () => {
  const { id } = useParams<"id">();
  const navigate = useNavigate();
  if (id == null) return null;
  return (
    <>
      <CompanyShow />
      <CompanyEditSheet
        open
        onOpenChange={(open) => {
          if (!open) navigate(`/companies/${id}/show`, { replace: true });
        }}
        companyId={id}
        history={false}
      />
    </>
  );
};
